export type ReactAppEnvironment =
  | "DEVELOP"
  | "TEST"
  | "STAGING"
  | "STAGE-NEW"
  | "PRODUCTION"
  | "SERVICES";

export const reactAppEnvironment =
  (import.meta.env.VITE_ENVIRONMENT as ReactAppEnvironment) || "DEVELOP";

export const isProd = reactAppEnvironment === "PRODUCTION";
export const isDev = reactAppEnvironment === "DEVELOP";
export const isTest = reactAppEnvironment === "TEST";
export const isStg =
  reactAppEnvironment === "STAGING" || reactAppEnvironment === "STAGE-NEW";

/**
 * TODO: Use url variables without "/api" suffix
 */
const stripApiSuffix = (apiUrl: string) =>
  apiUrl.endsWith("/api") ? apiUrl.slice(0, -4) : apiUrl;

const apiUrl = import.meta.env.VITE_API_URL || "";
const quicksightApiUrl = import.meta.env.VITE_QUICKSIGHT_API_URL || "";

// Safely remove "/api" suffix, with validation
export const BASE_PATH = stripApiSuffix(apiUrl);

// QuickSight service origin. OpenAPI paths are /admin/dashboards, /dashboards, etc. — no /api prefix.
export const QUICKSIGHT_BASE_PATH = stripApiSuffix(
  quicksightApiUrl.replace(/\/$/, ""),
);

// Optional: Add dev warning for misconfiguration
if (import.meta.env.DEV && !apiUrl) {
  console.warn("VITE_API_URL is not configured");
}

export const FRONTEND_BASE_NAME =
  import.meta.env.VITE_FRONTEND_BASE_NAME || "";
